<template>
  <div class="content c895">
    <h2>Zamrzovalnik 1</h2>
  </div>
  <div class="content c590">
    <div class="popup popDev5" style="display:none;">
      <div class="inner">
        <h3>Ali ste prepričani, da želite izbrisati napravo?</h3>
        <div class="msg">
          <h3>Zamrzovalnik</h3>
        </div>
        <div class="con">
          <p>Izbrišite napravo, če ste se zmotili pri njenih podatkih oziroma ste izbrali napačno napravo. Če bi želeli, jo lahko kasneje brez težav ponovno dodate.</p>
        </div>
        <div class="btns">
          <a
            href="javascript:void(0)"
            class="btn"
            title="Več"
            onclick="popupDelete(&quot;popDev5&quot;)"
          >NE, PREKLIČI</a>
          <a
            id="ctl00_ContentPlaceHolder1_lnkBtnDeleteDevice"
            class="btn"
            href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$lnkBtnDeleteDevice','')"
          >DA, IZBRIŠI</a>
        </div>
      </div>
    </div>
    <div class="appliance">
      <table>
        <tbody>
          <tr>
            <td class="first">Zamrzovalnik</td>
            <td>185 cm - 277 l zamrzovalne omare</td>
            <td>A+++ (po 2006)</td>
            <td class="last">
              <div class="tools">
                <a
                  href="javascript:void(0)"
                  title="Zbriši"
                  class="close"
                  onclick="popupDelete(&quot;popDev5&quot;)"
                >Zbriši</a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="appliance data">
      <div class="icon">
        <span class="Z">Zamrzovalnik</span>
      </div>
      <div class="first">
        <h5>TRENUTNA PORABA</h5>
        <span id="ctl00_ContentPlaceHolder1_lblConsumption">
          <span class="et">
            237 kWh / leto
            <div class="tooltip-bottom">
              Enotna tarifa (ET) je tarifa, ki jo beleži enotarifni števec vsak dan od 0.00 do 24.00 ure. Cena električne energije je ves čas enaka. V primeru, da imate enotarifno merjenje in želite dvotarifnega, pokličite v vaše elektrodistribucijsko podjetje za podrobnejše informacije.
              <br />
              <a
                href="http://www.uresnicujmo.si/o_aplikaciji_za_izracun_prihrankov/predstavitev#tarife"
                target="_blank"
                title="Več"
              >Več o tem &gt;</a>
            </div>
          </span>
        </span>
        <em>
          <span id="ctl00_ContentPlaceHolder1_lblTotalPrice">17,91 € / leto</span>
        </em>
      </div>

      <div class="no-data">
        <h5>VAŠI PRIHRANKI</h5>
        <h5>VAŠA NOVA PORABA</h5>
        <div class="message">
          <p>Za izračun nove porabe in prihrankov na izbrani napravi izvedi vsaj en ukrep.</p>
        </div>
      </div>
    </div>
    <div class="actions">
      <div class="toggle-btn" style="display:none;">
        <a href="javascript:void(0)" class="active">Prihranki zaradi izvedenih ukrepov</a>
      </div>
      <ul class="actionsExistingUl"></ul>

      <h3>Zmanjšajte naprave Zamrzovalnik</h3>
      <p>Zmanjšajte porabo tako, da izvedete vsaj enega, še bolje pa več, spodaj navedenih ukrepov. Izberite le tiste, ki so v vaših razmerah pomembni.</p>
      <ul>
        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_divAction">
          <a
            class="actionBtnMore active"
            style="cursor:pointer;"
          >Zamenjajmo naš stari zamrzovalnik z novim, ki je manjši in/ali bolj energetsko učinkovit</a>

          <div style class="actionPnlMore">
            <div id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_Panel1">
              <div class="form">
                <h3>Izberite lastnosti novega Zamrzovalnika:</h3>
                <fieldset>
                  <div class="f-item select">
                    <label for="type">Tip Zamrzovalnika:</label>
                    <table
                      id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_rblTypeFridge"
                      border="0"
                    >
                      <tbody>
                        <tr>
                          <td>
                            <input
                              id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_rblTypeFridge_0"
                              type="radio"
                              name="ctl00$ContentPlaceHolder1$RepeaterActions$ctl00$rblTypeFridge"
                              value="35"
                              checked="checked"
                            />
                            <label
                              for="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_rblTypeFridge_0"
                            >Zamrzovalne omare</label>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <input
                              id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_rblTypeFridge_1"
                              type="radio"
                              name="ctl00$ContentPlaceHolder1$RepeaterActions$ctl00$rblTypeFridge"
                              value="34"
                              onclick="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$RepeaterActions$ctl00$rblTypeFridge$1\',\'\')', 0)"
                            />
                            <label
                              for="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_rblTypeFridge_1"
                            >Zamrzovalne skrinje</label>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="f-item select">
                    <label for="volume">
                      Prostornina:
                      <span>(oz. višina)</span>
                    </label>
                    <span
                      id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_RequiredFieldValidator4"
                      style="color:Red;float:none;font-size:1em;visibility:hidden;"
                    >*</span>
                    <select
                      name="ctl00$ContentPlaceHolder1$RepeaterActions$ctl00$ddlSizeFridge"
                      id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_ddlSizeFridge"
                    >
                      <option value="48">61 cm - 53 l zamrzovalnika</option>
                      <option value="46">85 cm - 83,5 l zamrzovalnika</option>
                      <option value="47">85 cm - 90 l zamrzovalnika</option>
                      <option value="53">140 cm - 164 l zamrzovalnika</option>
                      <option value="50">141 cm - 168 l zamrzovalnika</option>
                      <option value="175">82 cm - 96 l zamrzovalne omare</option>
                      <option value="45">150 cm - 208 l zamrzovalnika</option>
                      <option value="49">153 cm - 174 l zamrzovalnika</option>
                      <option value="56">155 cm - 259 l zamrzovalnika</option>
                      <option value="51">163 cm - 240 l zamrzovalnika</option>
                      <option value="54">165 cm - 193 l zamrzovalnika</option>
                      <option value="55">170 cm - 210 l zamrzovalnika</option>
                      <option value="57">170 cm - 296 l zamrzovalnika</option>
                      <option value="52">173 cm - 210 l zamrzovalnika</option>
                      <option value="44">177 cm - 274 l zamrzovalnika</option>
                      <option value="176">84,5 cm - 94 l zamrzovalne omare</option>
                      <option value="43">180 cm - 217 l zamrzovalnika</option>
                      <option value="42">180 cm - 261 l zamrzovalnika</option>
                      <option value="174">185 cm - 277 l zamrzovalne omare</option>
                    </select>
                    <div class="help">
                      <a href="#" class="help" title="Help">Help</a>
                      <div class="tooltip">
                        Izberite ustrezno kombinacijo višine in prostornine zamrzovalnika.
                        <p></p>
                      </div>
                    </div>
                  </div>
                  <div class="f-item select">
                    <label for="class">
                      Energijski razred:
                      <span>(oz. leto izdelave naprave)</span>
                    </label>
                    <span
                      id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_RequiredFieldValidator5"
                      style="color:Red;float:none;font-size:1em;visibility:hidden;"
                    >*</span>
                    <select
                      name="ctl00$ContentPlaceHolder1$RepeaterActions$ctl00$ddlClassFridge"
                      id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_ddlClassFridge"
                    >
                      <option value="58">A+++ (po 2006)</option>
                      <option value="59">A++ (po 2006)</option>
                      <option value="60">A+ (po 2006)</option>
                      <option value="61">A (po 2006)</option>
                      <option value="62">B (2002-2006)</option>
                      <option value="63">C (1999-2002)</option>
                      <option value="64">D (1994-1999)</option>
                      <option value="65">E (pred 1994)</option>
                    </select>
                    <div class="help">
                      <a href="#" class="help" title="Help">Help</a>
                      <div class="tooltip">
                        Če ne poznate energijskega razreda zamrzovalnika, lahko glede na leto nakupa določite približen energijski razred. Pred določenim letom namreč aparatov nekaterih energijskih razredov še niso proizvajali.
                        <p></p>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>

              <div class="advice">
                <div class="right">
                  <a
                    id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_lnkBtnAdd"
                    class="btn"
                    href="javascript:WebForm_DoPostBackWithOptions(new WebForm_PostBackOptions(&quot;ctl00$ContentPlaceHolder1$RepeaterActions$ctl00$lnkBtnAdd&quot;, &quot;&quot;, true, &quot;ChangeDevice&quot;, &quot;&quot;, false, true))"
                  >Izvedi ukrep</a>
                </div>
                <p>Na porabo zamrzovalnika vplivajo: starost (zamrzovalnik, ki je star 10 let ali več), slabo tesnjenje, samodejno izklapljanje, ki ne deluje več, ter energijska učinkovitost. Če je naš zamrzovalnik star in nam povzroča težave, ali pa je prevelik za naše potrebe, je priporočljivo, da kupimo novega, ki je ustrezne velikosti in ima čim boljši energijski razred (A++ ali A+++). S tem bomo povečali prihranke na tej napravi.</p>
              </div>
            </div>
          </div>
        </li>

        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl01_divAction">
          <a
            class="actionBtnMore"
            style="cursor:pointer;"
          >Postavimo zamrzovalnik v hladnejši prostor</a>

          <div style="display:none;" class="actionPnlMore">
            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl01_lnkBtnAdd"
                  class="btn"
                  href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$RepeaterActions$ctl01$lnkBtnAdd','')"
                >Izvedi ukrep</a>
              </div>
              <p>Ko kupujemo zamrzovalnik, smo po navadi pozorni predvsem na njegovo velikost in energijski razred. Pozorni pa moramo biti tudi na to, pri kateri temperaturi okolice bo aparat brezhibno (najbolj učinkovito) deloval. Klimatski razred določi proizvajalec, podatek pa je zapisan na tablici s tehničnimi podatki. Zamrzovalnik postavite v hladen, dobro prezračevan prostor, če je to mogoče, vsekakor pa ne sodi na balkon ali kakšen drug prostor, neposredno obsijan s soncem.</p>
            </div>
          </div>
        </li>

        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl02_divAction">
          <a
            class="actionBtnMore"
            style="cursor:pointer;"
          >Preverimo nastavitev temperature zamrzovalnika</a>

          <div style="display:none;" class="actionPnlMore">
            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl02_lnkBtnAdd"
                  class="btn"
                  href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$RepeaterActions$ctl02$lnkBtnAdd','')"
                >Izvedi ukrep</a>
              </div>
              <p>Običajno je dovolj, da je temperatura v zamrzovalniku do -18 °C, zato preverimo, da temperatura znotraj zamrzovalnika ni prenizka. Za 1 % prihranka porabe energije dosežemo, če nastavitev temperature zmanjšamo za eno (1) odvečno °C (približamo proti -18 °C).</p>
            </div>
          </div>
        </li>

        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl03_divAction">
          <a
            class="actionBtnMore"
            style="cursor:pointer;"
          >Zamrzovalnik, ki ga ne potrebujemo, izklopimo</a>

          <div style="display:none;" class="actionPnlMore">
            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl03_lnkBtnAdd"
                  class="btn"
                  href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$RepeaterActions$ctl03$lnkBtnAdd','')"
                >Izvedi ukrep</a>
              </div>
              <p>Če uporabljamo več zamrzovalnikov, je priporočljivo, da jih, v primeru, ko jih ne potrebujemo, izklopimo. Še posebej je to primerno, če imamo zamrzovalnike, ki so stari 10 ali več let. Prihranimo lahko celo do 800 kWh električne energije na leto (odvisno od porabe izklopljenega zamrzovalnika).</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="advice">
      <h4>Imejte vedno v mislih, da lahko prihranite!</h4>
      <p>Zgornji ukrepi so merljivi in ob njihovem izvajanju točno veste, koliko energije lahko prihranite. Toda za vse električne naprave v gospodinjstvu, tako večje kot majhne, smo zbrali še kopico nasvetov, ki vam lahko pomagajo dodatno prihraniti, čeprav prihranka zaradi različnosti naprav in situacij za te nasvete ni mogoče količinsko opredeliti.</p>
      <a
        href="http://www.uresnicujmo.si/nasveti/hladilnik"
        target="_blank"
        alt="več"
        class="more"
      >PREBERITE NASVETE</a>
    </div>
  </div>
  <div class="content r-c">
    <div class="c282">
      <h3>PORABA NAPRAVE ZAMRZOVALNIK 1</h3>
      <div class="select">
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageType"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageType\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageType"
          class="s156"
        >
          <option selected="selected" value="1">Kumulativna poraba (€)</option>
          <option value="2">Kumulativna poraba (kWh)</option>
        </select>
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageTSpan"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageTSpan\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageTSpan"
        >
          <option selected="selected" value="1">za 1 leto</option>
          <option value="5">za 5 let</option>
          <option value="10">za 10 let</option>
          <option value="15">za 15 let</option>
        </select>
      </div>

      <div class="graph">
        <div class="chart">
          <div
            id="ctl00_ContentPlaceHolder1_divCurrentUsage"
            class="col without"
            style="height:100%;"
          >
            <span id="ctl00_ContentPlaceHolder1_lblCurrentUsage">17,91 €</span>
          </div>
        </div>
        <div class="legend">
          <div class="col">
            <strong>Poraba brez</strong> izvedenih ukrepov
          </div>
          <div class="col">
            <strong>Poraba z</strong> izvedenimi ukrepi
          </div>
        </div>
      </div>
    </div>
    <div class="c282">
      <h3>PORABA NAPRAVE ZAMRZOVALNIK 1</h3>
      <div class="select">
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageType2"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageType2\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageType2"
          class="s156"
        >
          <option selected="selected" value="1">Kumulativna poraba (€)</option>
          <option value="2">Kumulativna poraba (kWh)</option>
        </select>
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageTSpan2"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageTSpan2\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageTSpan2"
        >
          <option value="1">za 1 leto</option>
          <option selected="selected" value="5">za 5 let</option>
          <option value="10">za 10 let</option>
          <option value="15">za 15 let</option>
        </select>
      </div>
      <div class="graph image">
        <div class="chart">
          <img
            id="ctl00_ContentPlaceHolder1_Chart1"
            src="/Images/Charts/Chart000002.png?f4f62592-a253-46d9-b1eb-66cdf92e26a7"
            alt
            usemap="#ctl00_ContentPlaceHolder1_Chart1ImageMap"
            style="height:168px;width:263px;border-width:0px;padding:0;"
          />
          <map
            name="ctl00_ContentPlaceHolder1_Chart1ImageMap"
            id="ctl00_ContentPlaceHolder1_Chart1ImageMap"
          >
            <area
              shape="poly"
              coords="200, 144, 200, 46, 200, 46, 257, 22, 257, 22, 257, 144, 200, 144"
              title="13.11.2025; 89,53933625"
              alt
            />
            <area
              shape="poly"
              coords="144, 144, 144, 71, 144, 71, 200, 46, 200, 46, 200, 144, 144, 144"
              title="13.11.2024; 71,631469"
              alt
            />
            <area
              shape="poly"
              coords="87, 144, 87, 95, 87, 95, 144, 71, 144, 71, 144, 144, 87, 144"
              title="13.11.2023; 53,72360175"
              alt
            />
            <area
              shape="poly"
              coords="30, 144, 30, 119, 30, 119, 87, 95, 87, 95, 87, 144, 30, 144"
              title="13.11.2022; 35,8157345"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 22, 257, 22, 30, 119, 30, 119, 30, 144, 257, 144"
              title="13.11.2021; 17,90786725"
              alt
            />
            <area
              shape="poly"
              coords="200, 144, 200, 46, 200, 46, 257, 22, 257, 22, 257, 144, 200, 144"
              title="13.11.2025; 89,53933625"
              alt
            />
            <area
              shape="poly"
              coords="144, 144, 144, 71, 144, 71, 200, 46, 200, 46, 200, 144, 144, 144"
              title="13.11.2024; 71,631469"
              alt
            />
            <area
              shape="poly"
              coords="87, 144, 87, 95, 87, 95, 144, 71, 144, 71, 144, 144, 87, 144"
              title="13.11.2023; 53,72360175"
              alt
            />
            <area
              shape="poly"
              coords="30, 144, 30, 119, 30, 119, 87, 95, 87, 95, 87, 144, 30, 144"
              title="13.11.2022; 35,8157345"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 22, 257, 22, 30, 119, 30, 119, 30, 144, 257, 144"
              title="13.11.2021; 17,90786725"
              alt
            />
            <area
              shape="poly"
              coords="200, 144, 200, 46, 200, 46, 257, 22, 257, 22, 257, 144, 200, 144"
              title="13.11.2025; 89,53933625"
              alt
            />
            <area
              shape="poly"
              coords="144, 144, 144, 71, 144, 71, 200, 46, 200, 46, 200, 144, 144, 144"
              title="13.11.2024; 71,631469"
              alt
            />
            <area
              shape="poly"
              coords="87, 144, 87, 95, 87, 95, 144, 71, 144, 71, 144, 144, 87, 144"
              title="13.11.2023; 53,72360175"
              alt
            />
            <area
              shape="poly"
              coords="30, 144, 30, 119, 30, 119, 87, 95, 87, 95, 87, 144, 30, 144"
              title="13.11.2022; 35,8157345"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 22, 257, 22, 30, 119, 30, 119, 30, 144, 257, 144"
              title="13.11.2021; 17,90786725"
              alt
            />
            <area
              shape="poly"
              coords="200, 144, 200, 46, 200, 46, 257, 22, 257, 22, 257, 144, 200, 144"
              title="13.11.2025; 89,53933625"
              alt
            />
            <area
              shape="poly"
              coords="144, 144, 144, 71, 144, 71, 200, 46, 200, 46, 200, 144, 144, 144"
              title="13.11.2024; 71,631469"
              alt
            />
            <area
              shape="poly"
              coords="87, 144, 87, 95, 87, 95, 144, 71, 144, 71, 144, 144, 87, 144"
              title="13.11.2023; 53,72360175"
              alt
            />
            <area
              shape="poly"
              coords="30, 144, 30, 119, 30, 119, 87, 95, 87, 95, 87, 144, 30, 144"
              title="13.11.2022; 35,8157345"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 22, 257, 22, 30, 119, 30, 119, 30, 144, 257, 144"
              title="13.11.2021; 17,90786725"
              alt
            />
            <area
              shape="poly"
              coords="200, 144, 200, 46, 200, 46, 257, 22, 257, 22, 257, 144, 200, 144"
              title="13.11.2025; 89,53933625"
              alt
            />
            <area
              shape="poly"
              coords="144, 144, 144, 71, 144, 71, 200, 46, 200, 46, 200, 144, 144, 144"
              title="13.11.2024; 71,631469"
              alt
            />
            <area
              shape="poly"
              coords="87, 144, 87, 95, 87, 95, 144, 71, 144, 71, 144, 144, 87, 144"
              title="13.11.2023; 53,72360175"
              alt
            />
            <area
              shape="poly"
              coords="30, 144, 30, 119, 30, 119, 87, 95, 87, 95, 87, 144, 30, 144"
              title="13.11.2022; 35,8157345"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 22, 257, 22, 30, 119, 30, 119, 30, 144, 257, 144"
              title="13.11.2021; 17,90786725"
              alt
            />
            <area
              shape="poly"
              coords="200, 144, 200, 46, 200, 46, 257, 22, 257, 22, 257, 144, 200, 144"
              title="13.11.2025; 89,53933625"
              alt
            />
            <area
              shape="poly"
              coords="144, 144, 144, 71, 144, 71, 200, 46, 200, 46, 200, 144, 144, 144"
              title="13.11.2024; 71,631469"
              alt
            />
            <area
              shape="poly"
              coords="87, 144, 87, 95, 87, 95, 144, 71, 144, 71, 144, 144, 87, 144"
              title="13.11.2023; 53,72360175"
              alt
            />
            <area
              shape="poly"
              coords="30, 144, 30, 119, 30, 119, 87, 95, 87, 95, 87, 144, 30, 144"
              title="13.11.2022; 35,8157345"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 22, 257, 22, 30, 119, 30, 119, 30, 144, 257, 144"
              title="13.11.2021; 17,90786725"
              alt
            />
            <area
              shape="poly"
              coords="200, 144, 200, 46, 200, 46, 257, 22, 257, 22, 257, 144, 200, 144"
              title="13.11.2025; 89,53933625"
              alt
            />
            <area
              shape="poly"
              coords="144, 144, 144, 71, 144, 71, 200, 46, 200, 46, 200, 144, 144, 144"
              title="13.11.2024; 71,631469"
              alt
            />
            <area
              shape="poly"
              coords="87, 144, 87, 95, 87, 95, 144, 71, 144, 71, 144, 144, 87, 144"
              title="13.11.2023; 53,72360175"
              alt
            />
            <area
              shape="poly"
              coords="30, 144, 30, 119, 30, 119, 87, 95, 87, 95, 87, 144, 30, 144"
              title="13.11.2022; 35,8157345"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 22, 257, 22, 30, 119, 30, 119, 30, 144, 257, 144"
              title="13.11.2021; 17,90786725"
              alt
            />
            <area
              shape="poly"
              coords="200, 144, 200, 46, 200, 46, 257, 22, 257, 22, 257, 144, 200, 144"
              title="13.11.2025; 89,53933625"
              alt
            />
            <area
              shape="poly"
              coords="144, 144, 144, 71, 144, 71, 200, 46, 200, 46, 200, 144, 144, 144"
              title="13.11.2024; 71,631469"
              alt
            />
            <area
              shape="poly"
              coords="87, 144, 87, 95, 87, 95, 144, 71, 144, 71, 144, 144, 87, 144"
              title="13.11.2023; 53,72360175"
              alt
            />
            <area
              shape="poly"
              coords="30, 144, 30, 119, 30, 119, 87, 95, 87, 95, 87, 144, 30, 144"
              title="13.11.2022; 35,8157345"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 22, 257, 22, 30, 119, 30, 119, 30, 144, 257, 144"
              title="13.11.2021; 17,90786725"
              alt
            />
            <area
              shape="poly"
              coords="200, 144, 200, 46, 200, 46, 257, 22, 257, 22, 257, 144, 200, 144"
              title="13.11.2025; 89,53933625"
              alt
            />
            <area
              shape="poly"
              coords="144, 144, 144, 71, 144, 71, 200, 46, 200, 46, 200, 144, 144, 144"
              title="13.11.2024; 71,631469"
              alt
            />
            <area
              shape="poly"
              coords="87, 144, 87, 95, 87, 95, 144, 71, 144, 71, 144, 144, 87, 144"
              title="13.11.2023; 53,72360175"
              alt
            />
            <area
              shape="poly"
              coords="30, 144, 30, 119, 30, 119, 87, 95, 87, 95, 87, 144, 30, 144"
              title="13.11.2022; 35,8157345"
              alt
            />
          </map>
        </div>
        <div class="legend">
          <ul>
            <li class="without">Poraba brez izvedenih ukrepov</li>
            <li class="with">Poraba z izvedenimi ukrepi</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.data .icon .Z {
  background-position: -431px -95px;
}
</style>